import api from '../helpers/axiosConfig';

/**
 * Create a payment order with OPay
 * @param {Object} orderData - Order data including amount, order number, etc.
 * @returns {Promise} - Promise resolving to order details
 */
export const createPaymentOrder = async (orderData) => {
  try {
    // Default values for required fields
    const defaultUserInfo = {
      userEmail: 'customer@example.com',
      userId: 'guest-user-' + Date.now(),
      userMobile: '+2010000000000',
      userName: 'Guest Customer',
    };

    // Create a default product if none provided
    const defaultProducts = [
      {
        productId: 'prod-default',
        name: 'Product',
        description: 'Product description',
        price: orderData.amount || 100,
        quantity: 1,
        imageUrl: '',
      },
    ];

    // Map product items or use defaults ensuring required fields
    const productList = orderData.orderDetails?.items?.length
      ? orderData.orderDetails.items.map((item) => ({
          productId: item.id || `prod${Math.floor(Math.random() * 10000)}`,
          name: item.name || 'Product item',
          description:
            item.description || `Description for ${item.name || 'Product'}`,
          price:
            item.price ||
            orderData.amount / (orderData.orderDetails.items.length || 1),
          quantity: item.quantity || 1,
          imageUrl: item.imageUrl || '',
        }))
      : defaultProducts;

    // Prepare the new payload format
    const paymentPayload = {
      amount: orderData.amount,
      currency: 'EGP',
      productList: productList,
      userInfo: {
        userEmail: orderData.userInfo?.userEmail || defaultUserInfo.userEmail,
        userId: orderData.userInfo?.userId || defaultUserInfo.userId,
        userMobile:
          orderData.userInfo?.userMobile || defaultUserInfo.userMobile,
        userName: orderData.userInfo?.userName || defaultUserInfo.userName,
      },
      returnUrl: window.location.href + '?payment=success',
      callbackUrl: 'https://ghassan.dev1.prodevr.com/api/opay/webhook',
      cancelUrl: window.location.href + '?payment=cancel',
      payMethod: 'BankCard',
    };

    console.log('Sending payment request:', paymentPayload);

    // Use our API with axiosConfig
    const response = await api.post('/opay/payment', paymentPayload);

    const { success, message, data } = response.data;

    if (success) {
      return {
        success: true,
        data: {
          orderNo: data.orderNo,
          outOrderNo: data.reference,
          cashierUrl: data.cashierUrl,
          status: data.status,
          amount: data.amount,
        },
      };
    } else {
      throw new Error(message || 'Failed to create payment order');
    }
  } catch (error) {
    console.error('Payment creation error:', error);
    return {
      success: false,
      error:
        error.response?.data?.message ||
        error.message ||
        'Unknown error occurred',
    };
  }
};

/**
 * Query order status
 * @param {Object} params - OrderNo or reference
 * @returns {Promise} - Promise resolving to order status
 */
export const queryOrderStatus = async ({ orderNo, reference }) => {
  try {
    if (!orderNo && !reference) {
      throw new Error('Either orderNo or reference is required');
    }

    const response = await api.get('/opay/status', {
      params: {
        orderNo,
        reference,
      },
    });

    const { success, message, data } = response.data;

    if (success) {
      return {
        success: true,
        data: data,
      };
    } else {
      throw new Error(message || 'Failed to query order status');
    }
  } catch (error) {
    console.error('Status query error:', error);
    return {
      success: false,
      error:
        error.response?.data?.message ||
        error.message ||
        'Unknown error occurred',
    };
  }
};

export default {
  createPaymentOrder,
  queryOrderStatus,
};
